module.exports = __webpack_public_path__ + "static/media/not-found-img.f7578332.png";